import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  getNotificationSetUserInfo(parameters={}) {
    return core.call({
      url: '/api/v1/set/getNotificationSetUserInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveNotificationSetUserInfo(parameters={}) {
    return core.call({
      url: '/api/v1/set/saveNotificationSetUserInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getDashboardSetUserInfo(parameters={}) {
    return core.call({
      url: '/api/v1/set/getDashboardSetUserInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveDashboardSetUserInfo(parameters={}) {
    return core.call({
      url: '/api/v1/set/saveDashboardSetUserInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getMyCstmrRegSetUserInfo(parameters={}) {
    return core.call({
      url: '/api/v1/set/getMyCstmrRegSetUserInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveMyCstmrRegSetUserInfo(parameters={}) {
    return core.call({
      url: '/api/v1/set/saveMyCstmrRegSetUserInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
}

